/**
 *  Created by daiwenjuan on 2019/3/21 下午2:09.
 */
export var ID = '@civilService';
export default {
    ID: ID,
    GET_OFFICIAL_CARD: ID + "/GET_OFFICIAL_CARD",
};
